// KPI Period Module - Common Constants and Configurations

export const DOMAIN_NAME = 'kpiPeriod';
export const PERIOD_ROUTE_ID = 35;

// API Endpoints
export const API_ENDPOINTS = {
  CREATE: '/kpi/period/create',
  GET_ALL: '/kpi/period/get/all',
  GET_BY_ID: '/kpi/period/get',
  UPDATE: '/kpi/period/update',
  DELETE: '/kpi/period/delete',
};

// Table Columns Configuration
export const TABLE_COLUMNS = [
  { id: 'name', label: 'Period Name', sortable: true },
  { id: 'startDate', label: 'Start Date', sortable: true },
  { id: 'endDate', label: 'End Date', sortable: true },
  { id: 'durationDays', label: 'Duration (Days)', sortable: false },
  { id: 'updatedBy', label: 'Updated By', sortable: false },
  { id: 'updatedAt', label: 'Updated At', sortable: true },
  { id: 'actions', label: 'Actions', sortable: false, align: 'center' },
];

// Column Widths (percentage-based for responsive layout)
export const COLUMN_WIDTHS = {
  name: '18%',
  startDate: '13%',
  endDate: '13%',
  durationDays: '12%',
  updatedBy: '15%',
  updatedAt: '13%',
  actions: '10%',
};

// Sort Options
export const SORT_OPTIONS = [
  { value: 'name', label: 'Name' },
  { value: 'startDate', label: 'Start Date' },
  { value: 'endDate', label: 'End Date' },
  { value: 'updatedAt', label: 'Updated At' },
];

// Default Pagination
export const DEFAULT_PAGINATION = {
  limit: 10,
  offset: 1,
};

// Validation Messages
export const VALIDATION_MESSAGES = {
  NAME_REQUIRED: 'Period name is required',
  START_DATE_REQUIRED: 'Start date is required',
  END_DATE_REQUIRED: 'End date is required',
  INVALID_DATE_RANGE: 'End date must be after start date',
  DELETE_CONFIRMATION: 'Are you sure you want to delete this KPI period?',
  DELETE_IN_USE: 'Cannot delete period as it is currently in use',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  CREATE: 'KPI period created successfully',
  UPDATE: 'KPI period updated successfully',
  DELETE: 'KPI period deleted successfully',
};

// Date Format
export const DATE_FORMAT = 'YYYY-MM-DD';
export const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';

// Error message extraction utility
export const getErrorMessage = (error, defaultMessage) => {
    // Prioritize API response message if it's a string
    if (error?.response?.data?.message && typeof error.response.data.message === 'string') {
        return error.response.data.message;
    }
    // Fall back to error message
    if (error?.message) {
        return error.message;
    }
    // Use default message
    return defaultMessage;
};
